import ContentLoader from "react-content-loader";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";
import { merge } from "react-merge";
import { useEffect } from "react";

const styles = {
    mobile: {
        wrapper: {
            marginTop: "7.96vw",
            padding: "7.48vw 4.83vw"
        },
        card: {
            width: "100%",
            height: "144vw",
            backgroundColor: Color.White
        }
    },
    desktop: {
        wrapper: {
            marginTop: "1.25vw",
            padding: "0"
        },
        card: {
            width: "100%",
            height: "36.30vw",
            backgroundColor: Color.White
        }
    }
};

export const CandidateTabPanelLoader: React.FC = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    var loaderStyles = styles.mobile;
    if (!isMobile) {
        let extendStyles = merge(styles.mobile, styles.desktop);
        loaderStyles = extendStyles;
    }

    useEffect(() => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }, []);

    return (
        <div style={loaderStyles.wrapper}>
            <div style={loaderStyles.card}>
            <ContentLoader
                speed={1}
                width={"100%"}
                height={loaderStyles.card.height}
                backgroundColor={Color.LoaderBackground}
                foregroundColor={Color.LoaderForeground}
            >
                {isMobile ? <>
                    <circle cx="16.78%" cy="8.11%" r="9.58%" />
                    <rect x="34.56%" y="1.31%" rx="5" ry="5" width="55.67%" height="4.54%"/>
                    <rect x="34.56%" y="6.97%" rx="5" ry="5" width="43.40%" height="2.91%"/>
                    <rect x="34.56%" y="11.10%" rx="5" ry="5" width="37.22%" height="2.91%"/>
                    <rect x="0%" y="24.17%" rx="3" ry="3" width="90%" height="6.04%"/>
                    <rect x="0%" y="33.55%" rx="3" ry="3" width="49%" height="4.38%"/>
                    <rect x="0%" y="43.08%" rx="3" ry="3" width="100%" height="10.54%"/>
                    <rect x="0%" y="58.79%" rx="3" ry="3" width="100%" height="10.38%"/>
                    <rect x="0%" y="73.54%" rx="3" ry="3" width="100%" height="10.38%"/>
                    <rect x="0%" y="88.29%" rx="3" ry="3" width="100%" height="10.38%"/>
                </> :
                <>
                    <circle cx="12.78%" cy="11.27%" r="9.59%" />
                    <rect x="30.56%" y="1.83%" rx="5" ry="5" width="55.67%" height="6.31%"/>
                    <rect x="30.56%" y="9.69%" rx="5" ry="5" width="43.40%" height="4.04%"/>
                    <rect x="30.56%" y="15.44%" rx="5" ry="5" width="37.22%" height="4.04%"/>
                    <rect x="0%" y="25.95%" rx="3" ry="3" width="90%" height="6.61%"/>
                    <rect x="0%" y="37.16%" rx="3" ry="3" width="56%" height="4.05%"/>
                    <rect x="0%" y="44.88%" rx="3" ry="3" width="100%" height="11.32%"/>
                    <rect x="0%" y="59.95%" rx="3" ry="3" width="100%" height="11.53%"/>
                    <rect x="0%" y="74.23%" rx="3" ry="3" width="100%" height="11.53%"/>
                    <rect x="0%" y="88.51%" rx="3" ry="3" width="100%" height="11.53%"/>
                </>}                     
            </ContentLoader>
        </div>
        </div>
    );
}